interface LoggerColors {
  info: string;
  error: string;
  success: string;
  warn: string;
  log: string;
}

const defaultLoggerColors: Required<LoggerColors> = {
  info: '#2196F3',
  error: '#F44336',
  success: '#4CAF50',
  warn: '#FF9800',
  log: '#999999',
};

export default class Logger {
  private name: string;
  private colors: LoggerColors;

  constructor(name = '', colors: Partial<LoggerColors> = defaultLoggerColors) {
    this.name = name.toUpperCase();
    this.colors = { ...defaultLoggerColors, ...colors };
  }

  private logWithColor(color: string, ...args: any[]): void {
    const message = args.join(' ');
    console.log(`%c[${this.name}] %c${message}`, `color: ${color}`, `color: ${color}`);
  }

  groupCollapsed(...args: any[]): void {
    const message = args.join(' ');
    console.groupCollapsed(
      `%c[${this.name}] %c${message}`,
      `color: ${this.colors.success}`,
      `color: ${this.colors.success}`,
    );
  }

  groupEnd(): void {
    console.groupEnd();
  }

  info(...args: any[]): void {
    this.logWithColor(this.colors.info, ...args);
  }

  error(...args: any[]): void {
    this.logWithColor(this.colors.error, ...args);
  }

  success(...args: any[]): void {
    this.logWithColor(this.colors.success, ...args);
  }

  warn(...args: any[]): void {
    this.logWithColor(this.colors.warn, ...args);
  }

  log(...args: any[]): void {
    this.logWithColor(this.colors.log, ...args);
  }
}
